var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44665 5.38086H4.21998C3.73331 5.38086 3.33331 5.77419 3.33331 6.24753V12.7942C3.33331 13.2742 3.73331 13.6609 4.21998 13.6609H9.44665C9.93331 13.6609 10.3333 13.2675 10.3333 12.7942V6.24753C10.3333 5.72753 9.93331 5.38086 9.44665 5.38086Z",
    stroke: "#018897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3667 10.614H11.78C12.2667 10.614 12.6667 10.2207 12.6667 9.74732V3.20065C12.6667 2.68065 12.2667 2.33398 11.78 2.33398H6.55335C6.06669 2.33398 5.66669 2.72732 5.66669 3.20065V5.32732",
    stroke: "#018897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.544a005599837591a99a69a5d2cd65f0.svg";
export { ForwardRef as ReactComponent };